const questionTypes = Object.freeze({
  SeleccionMultiple: 1,
  VoF: 2,
  TextoAbierto: 3,
});

export default questionTypes;
